module.exports = {"411321100":"城关镇","411321101":"留山镇","411321102":"云阳镇","411321103":"皇路店镇","411321104":"南河店镇","411321105":"板山坪镇","411321106":"乔端镇","411321107":"白土岗镇","411321300":"城郊乡","411321301":"小店乡","411321302":"皇后乡","411321303":"太山庙乡","411321304":"石门乡","411321305":"四棵树乡","411321308":"马市坪乡","411321310":"崔庄乡","411321400":"河南红阳机械厂","411321401":"河南向东机械厂","411321402":"河南红宇机械厂","411321403":"国营东风机械厂","411321404":"国营长江机械厂"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411321.json
// module id = 1640
// module chunks = 0